import React from 'react';

import { ReportTagsSelectWithCreate } from 'components/Dashboards/Reporting/_common/ReportTagsSelectWithCreate/ReportTagsSelectWithCreate';
import classes from 'components/widgets/ReportsHome/ReportsTemplates/components/CreateReportFromTemplateModal/CreateReportFromTemplateForm/CreateReportFromTemplateForm.module.scss';
import { UseCreateReportFromTemplateModalLogic } from 'components/widgets/ReportsHome/ReportsTemplates/components/CreateReportFromTemplateModal/CreateReportFromTemplateModal.logic';

interface Props {
    logic: UseCreateReportFromTemplateModalLogic['logic'];
}

export const SelectingTags = ({ logic }: Props) => {
    return (
        <div className={classes.formField}>
            <label>Tags:</label>
            <ReportTagsSelectWithCreate control={logic.form.control} handleChange={logic.handleTagsChange} />
        </div>
    );
};
